import React from "react";
import { Scale, Briefcase, ShieldCheck, HeartHandshake } from "lucide-react";

const areas = [
  {
    icon: Scale,
    eyebrow: "Practice I",
    title: "Employment Law",
    body: "Wrongful termination, retaliation, discrimination, harassment, wage claims, severance negotiation, and whistleblower actions.",
  },
  {
    icon: Briefcase,
    eyebrow: "Practice II",
    title: "Business Disputes",
    body: "Partnership disputes, minority-owner squeezes, fiduciary-duty claims, and commercial contract litigation.",
  },
  {
    icon: ShieldCheck,
    eyebrow: "Practice III",
    title: "Elder Law",
    body: "Abuse claims involving older Utahns and their families.",
  },
  {
    icon: HeartHandshake,
    eyebrow: "Practice IV",
    title: "Personal Injury",
    body: "Representation for individuals injured by another\u2019s negligence or recklessness.",
  },
];

export default function PracticeAreas() {
  return (
    <section
      id="practice"
      data-testid="practice-areas-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Section heading */}
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <p className="text-overline mb-6">
              <span className="kb-counter mr-2">N&deg; 02</span> The Practice
            </p>
            <h2 className="font-serif-display font-medium text-[#0f172a] tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              Areas of
              <span className="block italic text-[#1a362d]">Concentration.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-6">
            <span className="gold-rule-solid mb-6" />
            <p className="text-[#475569] text-base md:text-lg leading-relaxed">
              Ms. Bollinger&rsquo;s practice is intentional and limited. She
              is a strategic problem solver who combines creative legal
              thinking with sharp instincts. Deeply invested in each matter
              she takes, she brings both analytical rigor and persuasive force
              to bear in pursuit of meaningful results.
            </p>
          </div>
        </div>

        {/* Bento grid 2x2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#bfa15f]/30">
          {areas.map((area, i) => {
            const Icon = area.icon;
            return (
              <article
                key={area.title}
                data-testid={`practice-card-${i}`}
                className="practice-card flex flex-col gap-6 min-h-[300px]"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3 text-[#bfa15f]">
                    <Icon className="w-5 h-5" strokeWidth={1.4} />
                    <span className="text-overline">{area.eyebrow}</span>
                  </div>
                  <span className="kb-counter text-2xl">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif-display text-3xl md:text-4xl text-[#0f172a] tracking-tight leading-tight">
                  {area.title}
                </h3>
                <p className="text-[#475569] text-[15px] md:text-base leading-relaxed">
                  {area.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
